import createStatusChipIndicator from '@/components/statuses/factory/createStatusChipIndicator';

import GENERAL_STATUSES from './options';

const GeneralStatus = createStatusChipIndicator({
  prefix: 'general',
  options: GENERAL_STATUSES,
  defaultSx: ({ palette, spacing }) => ({
    '&.IndicatorChip-root': {
      color: palette.text.primary,
      p: spacing(0, 0.5),
      borderColor: 'transparent',
      height: spacing(3),
      gap: 0.5,
      alignItems: 'center'
    },
    '&.IndicatorChip-root.Mui-selected': {
      borderColor: palette.primary.main
    },
    '& .MuiChip-label': {
      p: 0
    }
  }),
  translationNamespace: 'filters'
});

export default GeneralStatus;
